export class ApiError extends Error {
  status?: number;

  constructor({ message, status, cause }: { message: string; status?: number; cause?: ErrorOptions["cause"] }) {
    super(message, { cause });

    this.name = "ApiError";
    this.status = status;

    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
